import React, { useEffect } from "react";

import { useParams } from "react-router-dom";
import WorkCreateSelectPage from "./WorkCreateSelectPage";
import WorkCreateFormPage from "./WorkCreateFormPage";
import {
  TempDocumentDetailResponseWithAny,
  useTempDocumentDetailQuery,
} from "features/document/hooks/queries/useTempDocumentDetailQuery";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  selectedWorkCompanyState,
  selectedWorkPjTagState,
  selectedWorkTopicTagsState,
  workFormStepState,
} from "store/document/workDocument";
import { FormProvider, useForm } from "react-hook-form";
import { DocumentForm } from "features/document/utils/getTempSaveRequest";
import useResetWorkDocStates from "features/document/hooks/create/useResetWorkDocStates";
import useResetDocStates from "features/document/hooks/create/useResetDocStates";
import {
  getCompanyTagFromTempDoc,
  getPjTagFromTempDoc,
  getTopicTagFromTempDoc,
} from "features/document/utils/getTag";
const DocumentCreatePage = () => {
  const tempDocumentUuid = useParams().uuid;

  const { data: tempDocumentDetail, isLoading } =
    useTempDocumentDetailQuery(tempDocumentUuid);

  /* 폼 */
  const methods = useForm<DocumentForm>({
    mode: "onBlur",
  });

  const { workFormStep } = useWorkFormStep(tempDocumentDetail);

  useInitWorkDocStates();

  if (isLoading) return null;

  return (
    <FormProvider {...methods}>
      {workFormStep === 0 ? (
        <WorkCreateSelectPage />
      ) : (
        <WorkCreateFormPage tempDocumentDetail={tempDocumentDetail} />
      )}
    </FormProvider>
  );
};

export default DocumentCreatePage;

/* Hooks */
const useWorkFormStep = (
  tempDocumentDetail?: TempDocumentDetailResponseWithAny,
) => {
  /* 문서 등록 페이지 스텝 */
  const [workFormStep, setWorkFormStep] = useRecoilState(workFormStepState);

  const { resetWorkDocStates } = useResetWorkDocStates();

  const setCompanyTag = useSetRecoilState(selectedWorkCompanyState);
  const setPjTag = useSetRecoilState(selectedWorkPjTagState);
  const setTopicTags = useSetRecoilState(selectedWorkTopicTagsState);

  // 임시 저장 문서가 존재하면 다음 스텝으로 이동
  useEffect(() => {
    if (tempDocumentDetail) {
      const savedComapnyTag = getCompanyTagFromTempDoc(tempDocumentDetail);
      const savedPjTag = getPjTagFromTempDoc(tempDocumentDetail);
      const savedTopicTags = getTopicTagFromTempDoc(tempDocumentDetail);

      if (savedComapnyTag)
        setCompanyTag({
          uuid: savedComapnyTag.tagUuid,
          name: savedComapnyTag.tagName,
        });
      if (savedPjTag) setPjTag(savedPjTag);
      if (savedTopicTags.length > 0) setTopicTags(savedTopicTags);

      setWorkFormStep(1);
    } else {
      resetWorkDocStates();
    }
  }, [tempDocumentDetail]);

  return {
    workFormStep,
  };
};

const useInitWorkDocStates = () => {
  /* Recoil 상태 초기화 */
  const workFormStep = useRecoilValue(workFormStepState);
  const { resetWorkDocStates } = useResetWorkDocStates();

  useResetDocStates({ step: workFormStep, resetDocStates: resetWorkDocStates });
};
